export const prompt = (baseUrl: string, fetchWithAuth: (url: string, options?: RequestInit) => Promise<Response>) => {
  return {
    /**
     * Play prompt
     * @param path Folder to read file from
     * @param filename Filename to read
     * @returns
     */
    play: async (path: string, filename: string) => {
      const url = new URL(`${baseUrl}/Play`);
      const params = new URLSearchParams();
      params.append('path', path);
      params.append('filename', filename);
      url.search = params.toString();
      const response = await fetchWithAuth(url.toString());
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.debug('prompt.play response', data);
      return data;
    }
  };
};
